import { LogStats } from './useLogStats'
import ReportPanel from './components/ReportPanel'

function makeStats(scenario: 'rich' | 'minimal' | 'empty'): LogStats {
  const base: LogStats = {
    success: 0, fail: 0, recovered: 0, captchaTotal: 0,
    successMessages: new Map(), failMessages: new Map(), recoveredMessages: new Map(),
    boosterOk: new Map(), boosterFail: new Map(),
    boosterOkCount: 0, boosterFailCount: 0, boosterTempCount: 0,
    okGrouped: {}, failGrouped: {}, tempGrouped: {},
    firstSuccessTs: 0,
    captchaTypes: {},
  } as any

  if (scenario === 'empty') return base

  if (scenario === 'minimal') {
    return {
      ...base,
      success: 12, fail: 4, recovered: 1,
      firstSuccessTs: Date.now() - 1000 * 60 * 30,
      captchaTotal: 2,
      successMessages: new Map([['домен.ру — успех — 3', 12]]),
      failMessages: new Map([['домен.ру — таймаут', 4]]),
    }
  }

  // rich = booster mode with multiple sites & failures
  const okItems = (site: string, n: number, baseKw: string[]) => Array.from({ length: n }, (_, i) => ({
    key: baseKw[i % baseKw.length],
    url: `https://${site}/p/${i % 30}`,
    position: String((i % 11) + 1),
    elapsed: String(20 + (i % 35)),
    brand: i % 19 === 0 ? 'Бренд' : undefined,
    captcha: i % 11 === 0 ? 'yandex_smart' : undefined,
  }))

  const okGrouped: Record<string, any> = {
    'topcat.ru': { count: 7315, items: okItems('topcat.ru', 30, [
      'топкат купить', 'топкат каталог', 'топкат цена', 'топкат москва',
      'топкат отзывы', 'топкат акции', 'топкат на заказ',
    ])},
    'sneaker.shop': { count: 245, items: okItems('sneaker.shop', 14, [
      'кроссовки nike', 'купить adidas', 'jordan 1 цена',
    ])},
    'autoparts.ru': { count: 88, items: okItems('autoparts.ru', 8, [
      'автозапчасти москва', 'фильтр масляный', 'тормозные колодки',
    ])},
  }

  const failGrouped: Record<string, any> = {
    serp_load_failed: { count: 87, items: Array.from({ length: 22 }, (_, i) => ({
      site: 'topcat.ru', key: 'топкат ' + (i + 1), proxy: `5.42.10.${100 + i}:8080`, captcha: '',
    }))},
    captcha_unsolved: { count: 22, items: Array.from({ length: 9 }, (_, i) => ({
      site: 'sneaker.shop', key: 'кроссовки ' + (i + 1), proxy: `5.42.99.${10 + i}:8080`, captcha: 'yandex_smart',
    }))},
    proxy_all_failed: { count: 12, items: Array.from({ length: 6 }, (_, i) => ({
      site: 'topcat.ru', key: '', proxy: `5.42.30.${i}:3128`, captcha: '',
    }))},
  }

  const tempGrouped: Record<string, any> = {
    yandex_429: { count: 9, items: Array.from({ length: 9 }, (_, i) => ({
      site: 'topcat.ru', key: 'топкат ' + i, proxy: `5.42.55.${i}:1080`, captcha: '',
    }))},
  }

  return {
    ...base,
    boosterOkCount: 7315 + 245 + 88,
    boosterFailCount: 87 + 22 + 12,
    boosterTempCount: 9,
    captchaTotal: 18,
    firstSuccessTs: Date.now() - 1000 * 60 * 60 * 4.5,
    okGrouped, failGrouped, tempGrouped,
  } as any
}

export default function ReportDemo() {
  const params = new URLSearchParams(window.location.search)
  const scenario = (params.get('s') as 'rich' | 'minimal' | 'empty' | null) || 'rich'
  const elapsed = parseInt(params.get('elapsed') || '16320') // 4ч 32м
  const running = params.get('running') !== '0'

  const stats = makeStats(scenario)

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="px-4 py-3 border-b border-border flex items-center gap-3">
        <h1 className="text-base font-semibold">Demo: ReportPanel</h1>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <a href="?s=rich" className={`px-2 py-1 rounded border ${scenario === 'rich' ? 'border-foreground/30 bg-muted' : 'border-border hover:bg-muted/40'}`}>Rich</a>
          <a href="?s=minimal" className={`px-2 py-1 rounded border ${scenario === 'minimal' ? 'border-foreground/30 bg-muted' : 'border-border hover:bg-muted/40'}`}>Minimal</a>
          <a href="?s=empty" className={`px-2 py-1 rounded border ${scenario === 'empty' ? 'border-foreground/30 bg-muted' : 'border-border hover:bg-muted/40'}`}>Empty</a>
          <a href="?s=rich&running=0" className={`px-2 py-1 rounded border ${!running ? 'border-foreground/30 bg-muted' : 'border-border hover:bg-muted/40'}`}>Stopped</a>
        </div>
      </div>
      <div className="max-w-[760px] mx-auto" style={{ height: 'calc(100vh - 49px)' }}>
        <ReportPanel stats={stats} elapsedSec={elapsed} running={running} />
      </div>
    </div>
  )
}
